module.exports = __webpack_public_path__ + "static/media/N16.e00a3dbe.jpg";